import Vue from 'vue'
import { ajax } from '@/plugins/ajax'

export default {
  namespaced: true,
  state: {
    details: [],
    loading: false
  },
  getters: {
    details: (state) => state.details,
    loading: (state) => state.loading
  },
  actions: {
    fetchAttribuesById({ commit }, id) {
      commit('setLoading', true);
      return new Promise((resolve, reject) => {
        ajax.get('ProductManagement/api/AttributeValuesQuery/' + id).then(r => {
          commit('setDetails', r.data);
          commit('setLoading', false);
          resolve(r.data)
        }).catch(e => reject(e))
      })
    },

    updateAttributeValues({ commit, dispatch }, model) {
      return ajax.put('ProductManagement/api/AttributeValues', model)
    },

    setProductAttributeSelectiveOptionsChecked({ commit }, { val, productAttributeIndex, groupIndex }) {
      commit('setProductAttributeSelectiveOptionsChecked', { val, productAttributeIndex, groupIndex });
    },
    setProductAttributeSingleOptionsChecked({ commit }, { val, productAttributeIndex, groupIndex }) {
      commit('setProductAttributeSingleOptionsChecked', { val, productAttributeIndex, groupIndex });
    },
    setProductAttributeStringValue({ commit }, { val, productAttributeIndex, groupIndex }) {
      commit('setProductAttributeStringValue', { val, productAttributeIndex, groupIndex });
    },
  },
  mutations: {
    setDetails(state, data) {
      state.details = data;
    },
    setLoading(state, value) {
      state.loading = value;
    },


    setProductAttributeSelectiveOptionsChecked(state, { val, productAttributeIndex, groupIndex }) {
      var group = state.details.attributeGroups[groupIndex];
      var productAttribute = group.productAttributes[productAttributeIndex];

      for (var i = 0; i < productAttribute.selectiveOptions.length; i++) {
        var v = val.filter(x => x.key == productAttribute.selectiveOptions[i].key);
        var item = { ...productAttribute.selectiveOptions[i], checked: v.length > 0 };
        Vue.set(productAttribute.selectiveOptions, i, item)
      }
    },

    setProductAttributeSingleOptionsChecked(state, { val, productAttributeIndex, groupIndex }) {
      var group = state.details.attributeGroups[groupIndex];
      var productAttribute = group.productAttributes[productAttributeIndex];
      productAttribute.singleOptions.forEach(item => { item.checked = false; });
      if (val) {
        val.checked = true;
      }
    },

    setProductAttributeStringValue(state, { val, productAttributeIndex, groupIndex }) {
      var group = state.details.attributeGroups[groupIndex];
      var productAttribute = group.productAttributes[productAttributeIndex];
      productAttribute.stringValue = val;
    },


  }
}
